function StoryCrad({ isTeacherTurn, currentReadingStroy }) {
  return (
    <div
      className={` 
                ${
                  isTeacherTurn ? "bg-white" : "bg-gray-200"
                } shadow-xl border-l-4 
                ${isTeacherTurn ? "border-yellow-500" : "border-gray-300"} 
                rounded-2xl p-4 md:p-6 shadow-xl hover:shadow-2xl transition-all w-full md:w-auto
              `}
    >
      <div>
        <span
          className={`inline-block px-3 py-1 ${
            isTeacherTurn ? "bg-purple-100" : "bg-transparent"
          } font-semibold rounded-lg text-md md:text-lg mb-2 ${
            isTeacherTurn ? "text-purple-700" : "text-gray-400"
          }`}
        >
          {currentReadingStroy.topic}
        </span>
        <p className="text-md md:text-lg text-gray-700 leading-relaxed">
          {currentReadingStroy.Story}
        </p>
      </div>
    </div>
  );
}

export default StoryCrad;
